import { render, staticRenderFns } from "./RecruiterCandidates.vue?vue&type=template&id=2744745a&scoped=true"
import script from "./RecruiterCandidates.vue?vue&type=script&lang=ts"
export * from "./RecruiterCandidates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2744745a",
  null
  
)

export default component.exports